import { TouchpointType } from '../models/entities/touchpointType';

export abstract class AddTouchpointDto {
  constructor(
    public parentSlideId: number,
    public touchpointType: TouchpointType,
    public touchpointStyleId: number,
  ) {}
}
